import { Bounds } from "../space/bounds";
import { RDisplay } from "../../ui/RotDisplay";
import { gameData } from "../../core/GameManager";

export enum TileVisibility {
  VISIBLE,
  SEEN,
  HIDDEN,
}

export class WorldTile<T, S> {
  seen = false;
  z = 1;

  constructor(
    public type: T,
    public adj: {
      up: S;
      left: S;
      right: S;
      down: S;
    }
  ) {}
}

export type DrawTileFn = (
  display: RDisplay,
  x: number,
  y: number,
  tile: WorldTile<T, S>,
  visibility: TileVisibility
) => void;

export class LevelMap<T, S> {
  tiles: WorldTile<T, S>[];
  constructor(
    public drawTile: DrawTileFn,
    public width: number,
    public height: number
  ) {
    this.tiles = [];
  }

  draw(
    display: RDisplay,
    bounds: Bounds,
    view: Bounds,
    visible: Map<number, boolean>
  ) {
    for (let y = view.y; y < view.h + view.y; y++) {
      for (let x = view.x; x < view.w + view.x; x++) {
        const t = this.tiles[y * this.width + x];
        t &&
          this.drawTile(
            display,
            x + bounds.x - view.x,
            y + bounds.y - view.y,
            t,
            visible.has(x + y * this.width)
              ? TileVisibility.VISIBLE
              : t.seen
              ? TileVisibility.SEEN
              : TileVisibility.HIDDEN
          );

        /**const dMapVal = gameData.dMapPlayer?.get({ x: x, y: y });
        if (dMapVal) {
          const dString = dMapVal.toString(16);
          display.drawAppend(
            x + bounds.x - view.x,
            y + bounds.y - view.y,
            dString[dString.length - 1],
            "#FFFFFF",
            "transparent"
          );
        }**/
      }
    }
  }

  fillAll(makeFillTile: () => WorldTile<T, S>) {
    this.tiles = [];
    const size = this.height * this.width;
    for (let i = 0; i < size; i++) {
      this.tiles.push(makeFillTile());
    }
  }
}
